import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import Telegram from "../../assets/icons/telegram.svg";
import Instagram from "../../assets/icons/insta.svg";
import WhatsApp from "../../assets/icons/whatsUp.svg";
const Footer = () => {
  const [todayVisitorsState, setTodayVisitorsState] = useState();
  const [yesterdayVisitorsState, setYesterdayVisitorsState] = useState();
  const [totalVisitorsState, setTotalVisitorsState] = useState();

  const _yesterdayVisitors = useSelector((state) => state.yesterdayVisitors);
  const _todayVisitors = useSelector((state) => state.todayVisitors);
  const _totalVisitors = useSelector((state) => state.totalVisitors);

  useEffect(() => {
    setYesterdayVisitorsState(_yesterdayVisitors);
    setTodayVisitorsState(_todayVisitors);
    setTotalVisitorsState(_totalVisitors);
  }, [_todayVisitors, _yesterdayVisitors, _totalVisitors]);

  return (
    <div className="font-IRANSansWeb  text-white font-semibold text-sm caret-transparent ">
      <div
        style={{ direction: "rtl" }}
        className=" w-full mx-auto flex flex-row  mt-12  py-3 bg-[#f5911e]
        screen700:flex-col screen700:pr-6 screen700:pl-4 screen700:py-3 screen1800:mt-20
        "
      >
        <div className="my-4 mx-auto screen700:hidden">
          {/* <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3239.814312718563!2d51.362611717443855!3d35.70618679999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e01ebc2ab5c8f%3A0xb66721b493af7ac5!2sbiuk%202!5e0!3m2!1sen!2s!4v1674376697783!5m2!1sen!2s"
            className="rounded-2xl w-[170px] h-[140px] mx-auto  outline-none
            screen1000:w-[150px] screen1000:h-[120px] screen800:w-[120px] screen800:h-[100px] screen800:mt-2 screen1800:w-[220px] screen1800:h-[170px] screen1800:my-4
            "
          ></iframe> */}
          {/* <a
            target="_blank"
            rel="noreferrer"
            href="https://www.google.com/maps/place/biuk+2/@35.7064126,51.3583638,16.71z/data=!4m6!3m5!1s0x3f8e01ebc2ab5c8f:0xb66721b493af7ac5!8m2!3d35.7061868!4d51.3648004!16s%2Fg%2F11gjwr4ngr"
          >
            <img
              src={map}
              alt="سکه شادمهر"
              className="rounded-2xl w-[170px] h-[140px] mx-auto  outline-none
            screen1000:w-[150px] screen1000:h-[120px] screen800:w-[120px] screen800:h-[100px] screen800:mt-2 screen1800:w-[220px] screen1800:h-[170px] screen1800:my-4
            "
            />
          </a> */}
          <iframe
            title="نقشه سکه شادمهر"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6479.610271789121!2d51.3583638!3d35.7064126!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e01ebc2ab5c8f%3A0xb66721b493af7ac5!2sbiuk%202!5e0!3m2!1sen!2s!4v1683092764855!5m2!1sen!2s"
            className="rounded-2xl w-[210px] h-[140px] mx-auto  outline-none
            screen1000:w-[175px] screen1000:h-[120px]  screen800:mt-2 screen1800:w-[250px] screen1800:h-[170px] screen1800:my-4
            "
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="w-1/4 mx-auto my-auto screen1000:text-[10px] screen700:w-full screen700:mb-2 screen1800:text-[18px] screen1800:leading-6">
          <div className="text-base  screen1000:text-[13px] screen500:text-[11px] screen1800:text-[22px] screen1800:mb-4">
            تماس با ما
          </div>
          <div className="screen1800:leading-8">
            <span className="font-normal ml-1 text-xs screen1800:text-[18px]">
              آدرس :
            </span>
            <span>ستارخان بهبودی بالاتر از نصرت پلاک ۲۲۱            </span>
          </div>

          <div style={{ direction: "rtl" }} className="my-2">
            <span className="font-normal text-xs screen1800:text-[18px]">
              تلفن :
            </span>
            <span> 91306125 021 - 09128383745</span>
          </div>
          <span className="font-normal text-xs screen1800:text-[18px]">
            ایمیل :
          </span>
          <span> biuk2com@gmail.com</span>
        </div>

        <div className="  my-auto screen700:mb-2 screen1800:leading-8">
          <div className="screen1000:text-[13px] screen500:text-[11px] screen1800:text-[22px] screen1800:mb-4">
            بازدید ها
          </div>
          <div className="screen700:flex">
            <div className="font-normal text-xs screen1000:text-[10px] screen400:text-[9px] screen1800:text-[18px]">
              بازدید امروز :
              <span className="font-semibold mr-1">{todayVisitorsState}</span>
            </div>
            <div className="font-normal  screen1800:my-2 text-xs screen1000:text-[10px]  screen400:text-[9px] screen1800:text-[18px] screen700:mx-6  screen400:mx-2 screen1800:leading-7">
              بازدید دیروز :
              <span className="font-semibold mr-1">
                {yesterdayVisitorsState}
              </span>
            </div>
            <div className="font-normal text-xs screen1000:text-[10px] screen1800:text-[18px] screen400:text-[9px]">
              بازدید کل :
              <span className="font-semibold mr-1">{totalVisitorsState}</span>
            </div>
          </div>
        </div>

        <div className="  mx-auto my-auto screen700:mx-0">
          <div className=" screen1000:text-[12px] screen500:text-[11px] screen1800:text-[18px] mb-4">
            ما در شبکه های اجتماعی
          </div>
          <div className="flex flex-row justify-around my-1 screen700:justify-start">
            <a target="_blank" rel="noreferrer" href="https://biuk2.com">
              <div>
                <img
                  alt="واتس اپ سکه شادمهر"
                  src={WhatsApp}
                  className="w-7 h-7 screen1000:w-6 screen1000:h-6 screen800:w-5 screen800:h-5 screen1800:w-8 screen1800:h-8"
                />
              </div>
            </a>
            <a target="_blank" rel="noreferrer" href="https://biuk2.com">
              <div className="mx-5 ">
                <img
                  alt="تلگرام سکه شادمهر"
                  src={Telegram}
                  className="w-7 h-7 screen1000:w-6 screen1000:h-6 screen800:w-5 screen800:h-5 screen1800:w-8 screen1800:h-8"
                />
              </div>
            </a>
            <a target="_blank" rel="noreferrer" href="https://biuk2.com">
              <div>
                <img
                  alt="اینستاگرام سکه شادمهر"
                  src={Instagram}
                  className="w-7 h-7 screen1000:w-6 screen1000:h-6 screen800:w-5 screen800:h-5 screen1800:w-8 screen1800:h-8"
                />
              </div>
            </a>
          </div>
        </div>
      </div>

      <div
        style={{ direction: "rtl" }}
        className="flex flex-row mx-auto justify-between bg-[#6d6e70]  px-2 py-1 font-extralight
        screen1000:text-[13px]  screen800:text-[10px]  screen700:text-[8px] screen500:flex-col  screen500:text-center  screen1800:text-[16px] screen1800:py-2 screen1800:px-3
        "
      >
        <div className=" ">
          کلیه حقوق مادی و معنوی این سایت متعلق به&nbsp;
          <span className="font-extrabold">
            سکه شادمهر 
          </span>
          می باشد و کپی از آن پیگرد قانونی دارد
        </div>

        <div className=" ">
          طراحی شده توسط شرکت &nbsp;
          <a
            href="https://telmis.ir/"
            className="cursor-pointer"
            target="_blank"
            rel="noreferrer"
          >
            <span className="font-bold text-[#f5911e]   ">تلمیس</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
